import React from 'react';
import { UsersHolidayInfo } from "../models/Holidays.model";
import { BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { ProgressBar } from '@shared/ui/atoms/ProgressBar';
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { roundDays } from '@shared/utils/MathUtils';

export function UsersHolidayUsageView(props: Props) {
  const {usersHolidayInfo} = props;
  const {t} = useTranslation();

  const totalAllowance = usersHolidayInfo.holidayAllowanceWithRollOver ?? usersHolidayInfo.holidayAllowance;

  return (
    <Wrapper style={props?.style ?? {}}>
      <HolidaysUsedRow>
        <DaysUsedContainer>
          <BodyVerySmall>{t('holidays.days-booked')}</BodyVerySmall>
          <HeadlineSmall>{usersHolidayInfo.daysUsed}</HeadlineSmall>
        </DaysUsedContainer>
        <DaysLeftContainer>
          <BodyVerySmall>{t('holidays.days-left')}</BodyVerySmall>
          <HeadlineSmall>{roundDays(totalAllowance - usersHolidayInfo.daysUsed)}</HeadlineSmall>
        </DaysLeftContainer>
      </HolidaysUsedRow>

      <ProgressBar style={{marginBottom: 4}} complete={usersHolidayInfo.daysUsed / totalAllowance * 100}/>

      <BodyVerySmall style={{textAlign: 'center'}}>{t('holidays.allowance', {number: totalAllowance})}</BodyVerySmall>
      {usersHolidayInfo.autoCarryOverInfo?.daysCarriedOver !== undefined && <BodyVerySmall colour={Colours.darkGrey} style={{textAlign: 'center'}}>{t('holidays.carried-over', {number: usersHolidayInfo.autoCarryOverInfo?.daysCarriedOver})}</BodyVerySmall>}

    </Wrapper>
  )
}

interface Props {
  usersHolidayInfo: UsersHolidayInfo;
  style?: any;
}


const HolidaysUsedRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`

const DaysLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  * {
    text-align: center;
  }
`
const DaysUsedContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  * {
    text-align: center;
  }
`

const Wrapper = styled.div`
  width: 100%;
`
